import styled from 'styled-components';

const SingleClaimConfirmModal = styled.div`
  display: flex;
  justify-content: space-between;
`;

export default SingleClaimConfirmModal;
